// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8fd18681","455":"487ad03b","977":"e9c75ad1"}[chunkId] + ".chunk.js";
};